import { render, staticRenderFns } from "./advert-banner.vue?vue&type=template&id=31ceb992&scoped=true"
import script from "./advert-banner.vue?vue&type=script&lang=js"
export * from "./advert-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ceb992",
  null
  
)

export default component.exports